module.exports = __webpack_public_path__ + "static/media/3DPPA28.b332c4b3.jpg";